{
  "AUTOMATION": {
    "HEADER": "Автоматизация",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Добавяне правило за автоматизация",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Добавяне правило за автоматизация",
      "SUBMIT": "Създаване",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Фаза"
        },
        "ORDER": {
          "LABEL": "Ред",
          "ERROR": "Редът е задължителен"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Действия"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Фаза",
        "ORDER": "Ред",
        "NAME": "Име",
        "DESCRIPTION": "Описание",
        "ACTIVE": "Активен",
        "CREATED_ON": "Created on",
        "WAIT": "Изчакване"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Всички",
        "INSTANT": "При събитие",
        "DELAYED": "Със закъснение"
      },
      "WAITS": "Чака {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Изтрий",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "CONFIRM": {
        "TITLE": "Потвърди изтриването",
        "MESSAGE": "Сигурни ли сте за изтриването ",
        "YES": "Да, изтрий ",
        "NO": "Не, запази "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Обновяване",
      "CANCEL_BUTTON_TEXT": "Отмени",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Редактирай",
      "CREATE": "Създаване",
      "DELETE": "Изтрий",
      "CANCEL": "Отмени",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Изберете имейл кутия и адрес на подателя",
      "SUBJECT_INPUT_PLACEHOLDER": "Тема на имейла",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Изберете SMS кутия, от която да се изпрати",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Въведете текста на SMS съобщението",
      "SMS_COUNTER": "{length}/{limit} знака, {segments} SMS (преди попълването на променливите)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Качване...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Изисква се стойност",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Стойността трябва да е между 0 и 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "Редът е задължителен",
      "ORDER_MUST_BE_AT_LEAST_ONE": "Редът трябва да е поне 1",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Това действие работи само когато фазата на правилото е зададена на \"Преди етикетиране\".",
      "SKIP_AUTO_LABELING": "Това действие работи само когато фазата на правилото е зададена на \"Преди етикетиране\".",
      "MOVE_CONVERSATION_TO_INBOX": "В имейл кутия могат да се преместват само имейл разговори и разговори от уеб чат, като уеб чат само ако контактът има имейл адрес. В останалите случаи разговорът не се премества, а вместо това се добавя лична бележка.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Започва нов разговор с контакта в избраната имейл кутия, изпраща му съобщението по имейл и маркира разговора като решен. Това се случва при всяко изпълнение на правилото. Ако контактът няма имейл адрес, нищо не се изпраща и вместо това се добавя лична бележка.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Започва нов разговор с контакта в избраната SMS кутия, изпраща му съобщението като SMS и маркира разговора като решен. Това се случва при всяко изпълнение на правилото. Съобщението е обикновен текст без прикачени файлове. Ако контактът няма телефонен номер, нищо не се изпраща и вместо това се добавя лична бележка."
    },
    "NOTICES": {
      "AI_PROMPT": "Всяко отделно оценяване се таксува.",
      "INCOMING_MESSAGES_COUNT": "Това се отнася до броя на входящите съобщения в разговора.",
      "OUTGOING_MESSAGES_COUNT": "Това се отнася до броя на изходящите съобщения в разговора."
    },
    "PHASE": {
      "BEFORE_LABELING": "Преди етикетиране",
      "AFTER_LABELING": "След етикетиране"
    },
    "NONE_OPTION": "Нито един",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Входящо съобщение",
      "OUTGOING": "Изходящо съобщение",
      "PRIVATE": "Лична бележка",
      "AI_SUMMARY": "AI обобщение"
    },
    "YES_NO_VALUES": {
      "YES": "Да",
      "NO": "Не"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Лично съобщение в Instagram",
      "FACEBOOK_COMMENT": "Коментар във Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Създаден разговор",
      "CONVERSATION_UPDATED": "Обновен разговор",
      "MESSAGE_CREATED": "Създадено съобщение",
      "CONVERSATION_OPENED": "Отворен разговор",
      "CONVERSATION_RESOLVED": "Разрешен разговор",
      "PHONE_CALL_FINISHED": "Приключило обаждане"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Присвояване на оператор",
      "ASSIGN_TEAM": "Присвояване на екип",
      "ADD_LABEL": "Добавяне на етикет",
      "REMOVE_LABEL": "Премахване на етикет",
      "SEND_EMAIL_TO_TEAM": "Изпращане на имейл до екип",
      "SEND_EMAIL_TRANSCRIPT": "Изпращане на имейл транскрипт",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Изпращане на подробен имейл транскрипт",
      "MUTE_CONVERSATION": "Заглушаване на разговор",
      "SNOOZE_CONVERSATION": "Отлагане на разговор",
      "RESOLVE_CONVERSATION": "Разрешаване на разговор",
      "OPEN_CONVERSATION": "Отваряне на разговор",
      "SEND_WEBHOOK_EVENT": "Изпращане на webhook събитие",
      "SEND_ATTACHMENT": "Изпращане на прикачен файл",
      "SEND_MESSAGE": "Изпращане на съобщение",
      "ADD_NOTE": "Добавяне на бележка",
      "CHANGE_PRIORITY": "Промяна на приоритета",
      "ADD_SLA": "Добавяне на SLA",
      "SKIP_AUTO_PRIORITY": "Пропускане на автоматичен приоритет",
      "SKIP_AUTO_LABELING": "Пропускане на автоматично етикетиране",
      "AUTO_TRANSLATE": "Превод на съобщението",
      "AUTO_TRANSLATE_CONVERSATION": "Превод на разговора",
      "MOVE_CONVERSATION_TO_INBOX": "Преместване на разговора в кутия",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Изпращане на съобщение в нов разговор",
      "SEND_SMS_IN_NEW_CONVERSATION": "Изпращане на SMS в нов разговор",
      "STOP_PROCESSING_RULES": "Спиране на обработката на правила"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Набран вътрешен номер",
      "AI_FILTER": "AI филтър",
      "MESSAGE_TYPE": "Тип на съобщението",
      "MESSAGE_CONTAINS": "Съдържание на съобщението",
      "EMAIL": "Имейл на контакта",
      "INBOX": "Кутия",
      "CHANNEL_TYPE": "Тип на кутията",
      "CONVERSATION_LANGUAGE": "Език на разговора",
      "PHONE_NUMBER": "Телефонен номер",
      "STATUS": "Статус",
      "BROWSER_LANGUAGE": "Език на браузъра",
      "MAIL_SUBJECT": "Тема на имейла",
      "COUNTRY_NAME": "Държава",
      "MARKETPLACE_COUNTRY": "Държава на маркетплейса",
      "REFERER_LINK": "Препращаща връзка",
      "ASSIGNEE_NAME": "Отговорник",
      "TEAM_NAME": "Екип",
      "PRIORITY": "Приоритет",
      "CALL_DIRECTION": "Посока на обаждането",
      "MISSED_CALL": "Пропуснато обаждане",
      "MISSED_CALL_COUNT": "Брой пропуснати обаждания",
      "MESSAGE_SOURCE_TYPE": "Тип на източника на съобщението",
      "INCOMING_MESSAGE_COUNT": "Брой входящи съобщения",
      "OUTGOING_MESSAGE_COUNT": "Брой изходящи съобщения",
      "LABEL": "Етикет",
      "EMAIL_RECIPIENTS": "Получател на имейл",
      "EMAIL_AUTO_REPLY": "Имейлът е автоматичен отговор",
      "ATTACHMENT_EXTENSION": "Разширение на прикачен файл",
      "WORKING_HOURS": "В рамките на работното време",
      "AGENT_REPLIED": "Агент е отговорил след промяната на статуса"
    },
    "WAIT": {
      "RUN_LABEL": "Изпълни действията",
      "INSTANT": "При събитие",
      "DELAYED": "Със закъснение",
      "TRIGGER_LABEL": "Изчакай, докато",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Разговор остава в статус",
        "CUSTOMER_UNRESPONSIVE": "Клиентът не отговаря на агент",
        "AGENT_UNRESPONSIVE": "Клиентът не получава отговор от агент"
      },
      "STATUS_LABEL": "Статус",
      "STATUSES": {
        "OPEN": "Отворен",
        "PENDING": "Изчакващ",
        "SNOOZED": "Отложен",
        "RESOLVED": "Решен"
      },
      "DELAY_LABEL": "Време за изчакване",
      "DELAY_ERROR": "Въведете време за изчакване между 1 минута и 30 дни",
      "DURATION": {
        "MINUTES": "{count} мин",
        "HOURS": "{count} ч",
        "DAYS": "{count} д"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Действията се изпълняват, когато разговорът е в статус {status} от {duration}. Промяна на статуса преди това ги отменя. Етикетите, работното време и отговорите на агенти се проверяват, когато изчакването приключи.",
        "CUSTOMER_UNRESPONSIVE": "Действията се изпълняват, когато клиентът не е отговорил от {duration} на съобщение на агент. Отговор на клиента ги отменя; ново съобщение на агента рестартира изчакването.",
        "AGENT_UNRESPONSIVE": "Действията се изпълняват, когато клиентът чака от {duration} без отговор от агент. Отговор на агента ги отменя."
      }
    }
  }
}
